import { Grid, Paper, Box } from '@mui/material';
import React from 'react';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import WorkIcon from "@mui/icons-material/Work";
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import { AddMenuHeadingAction } from '../../../../store/Menu/Action';
import history from '../../../../history';
import { useDispatch, useSelector } from 'react-redux';
import { checkPayrollAccess, getUserData } from '../../Base/helper/baseFunctions';
import CelebrationIcon from '@mui/icons-material/Celebration';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SummarizeIcon from '@mui/icons-material/Summarize';

const QuickLinks = ({ quicklinksData }) => {
  const userData = getUserData();
  const dispatch = useDispatch();
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const leaveAccess = atsModuleData?.find((item) => item.module_name === "Leave");
  const leaveUserAccess = atsModuleData?.find((item) => item.module_name === "LMS User");
  const ExternalUserCoreHr = atsModuleData?.some(
    (item) => item.module_name === "External User CoreHr"
  );
  const ShowLms = quicklinksData?.[0]?.lms?.[0];
  const ShowAts = quicklinksData?.[0]?.ats?.[0];
  const areAllFalse = obj => obj && Object.values(obj)?.every(value => value === false || value === null);
 
  const payrollAccess = checkPayrollAccess();
  const lmsUserAccess = userData?.f_country_code === "IND" && leaveAccess && leaveUserAccess && !areAllFalse(ShowLms)


  const lms = [
    { name: 'My Timesheet', icon: <PendingActionsIcon />, color: '#1769ff', show: ShowLms?.['My-Timesheet'] && !ExternalUserCoreHr, route: '/lms/manage-timesheet' },
    { name: 'Team', icon: <Diversity3Icon />, color: '#ea4c89', show: ShowLms?.['Team'], route: '/lms/manage-team' },
    { name: 'Holidays', icon: <CelebrationIcon />, color: '#ea4c89', show: true && !ExternalUserCoreHr, route: '/holidays' },
  ];

  const ats = [
    { name: 'Job Dashboard', icon: <WorkIcon />, color: '#ea4c89', show: ShowAts?.['ATS Job Dashboard'], route: '/ats/manage-job', menu: ' Job dashboard' },
    { name: 'Add Job', icon: <HomeRepairServiceIcon />, color: '#c32aa3', show: ShowAts?.['ATS Add Job'], route: '/ats/add-job/', menu: 'Add Job' },
    { name: 'Schedule Interview', icon: <CalendarMonthIcon />, color: '#1769ff', show: ShowAts?.['ATS Schedule Interview'], route: '/ats/dashboard', menu: 'ATS Dashboard' },
    { name: 'Reports', icon: <AssessmentIcon />, color: '#c32aa3', show: ShowAts?.['ATS Reports'], route: '/ats/reports/', menu: 'Operational Reports' },
    { name: 'ATS Settings', icon: <ContentPasteSearchIcon />, color: '#c32aa3', show: ShowAts?.['ATS Settings'], route: '/ats/ats-settings/', menu: 'ATS' },
    { name: 'Form Builder', icon: <DynamicFeedIcon />, color: '#c32aa3', show: ShowAts?.['ATS Feedback'], route: '/ats/ats-settings/', menu: 'ATS' },
  ];

  const payroll = [
    { name: "PayConfig", icon: <WorkIcon />, show: payrollAccess, route: "/payrollconfig-employee" },
    // { name: "Employee Time", icon: <WorkHistoryIcon />, show: payrollAccess, route: "/employee-time" },
    { name: "PayRun", icon: <SummarizeIcon />, route: "/payroll-management", show: payrollAccess, state: "grid" },
    { name: "PayReports", icon: <RequestQuoteIcon />, show: payrollAccess, route: "/myemployee-reports" },
  ]

  const handleMenuClick = (menu, route, name) => {
    sessionStorage.setItem("selectedMenu", menu);
    dispatch(AddMenuHeadingAction({ heading: menu }));
    if (route === '/ats/add-job/') {
      history.push({ pathname: route, state: { from: 'dashboard' } });
    }
    else if (name === 'Form Builder') {
      history.push({ pathname: route, state: { defaultValue: '4' } });
    }
    else {
      history.push(route);
    }
  }
  return (
    <Grid container justifyContent="center" alignItems="center">
      {lmsUserAccess && (
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginBottom: "16px" }}>
          <Paper elevation={3} className="folder">
            <div className="folder-title">MY TIME</div>
            <Grid container spacing={2}>
              {lms?.map((app, index) => (
                app.show && (
                  <Grid item xs={6} sm={4} md={4} key={index}>
                    <Box className="quick-app" onClick={() => handleMenuClick(app.name, app.route)}>
                      <div className="quick-app-icon">{app.icon}</div>
                      <div className="quick-app-name">{app.name}</div>
                    </Box>
                  </Grid>
                )
              ))}
            </Grid>
          </Paper>
        </Grid>
      )}

      {!areAllFalse(ShowAts) && (
        <Grid item xs={12} sm={12} md={12} lg={12} pb={2}>
          <Paper elevation={3} className="folder">
            <div className="folder-title">ATS</div>
            <Grid container spacing={2}>
              {ats?.map((app, index) => (
                app.show && (
                  <Grid item xs={6} sm={4} md={4} key={index}>
                    <Box className="quick-app" onClick={() => handleMenuClick(app.menu, app.route, app.name,)}>
                      <div className="quick-app-icon">{app.icon}</div>
                      <div className="quick-app-name">{app.name}</div>
                    </Box>
                  </Grid>
                )
              ))}
            </Grid>
          </Paper>
        </Grid>
      )}

      { payrollAccess && 
        ( <Grid item xs={12} sm={12} md={12} lg={12} pb={2}>
            <Paper elevation={3} className="folder">
              <div className="folder-title">PAYROLL MANAGEMENT</div>
              <Grid container spacing={2}>
                {payroll?.map((app, index) => (
                  app.show && (
                    <Grid item xs={6} sm={4} md={4} key={index}>
                      <Box className="quick-app" onClick={() => handleMenuClick(app.name, app.route)}>
                        <div className="quick-app-icon">{app.icon}</div>
                        <div className="quick-app-name">{app.name}</div>
                      </Box>
                    </Grid>
                  )
                ))}
              </Grid>
            </Paper>
          </Grid>
        )}
    </Grid>
  );
}

export default QuickLinks;
